import React from 'react';
import { Calculator, Users, Camera, Heart } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useInView } from '../hooks/useInView';
import { services } from '../data/mock';

const iconMap = {
  Calculator: Calculator,
  Users: Users,
  Camera: Camera,
  Heart: Heart
};

const ServicesSection = () => {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section ref={ref} className="py-20 bg-[#8B2942]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center mb-12 transition-all duration-400 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Nos services</h2>
          <p className="text-white/80 max-w-2xl mx-auto">
            Un accompagnement complet pour votre projet immobilier
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className={`transition-all duration-400 ${
                  isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <Card className="bg-white/10 border-white/20 h-full hover:bg-white/20 transition-colors duration-300 group">
                  <CardContent className="p-6 text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors duration-300">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                    <h3 className="text-lg font-semibold text-white mb-2">{service.title}</h3>
                    <p className="text-white/80 text-sm leading-relaxed">{service.description}</p>
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
